document.addEventListener('DOMContentLoaded', function () {
    const links = {
        'mi-card-ein-1': '/der-weg-zur-ersten-sitzung/',
        'mi-card-ein-2': '/so-laeuft-eine-sitzung-ab/',
        'mi-card-ein-3': '/coaching-vs-therapy/',
        'mi-card-ein-4': '/der-mutdrache/',
        'mi-card-ein-5': '/tools-elternrolle/',
        'mi-card-ein-6': '/kontakt/'
    };

    Object.entries(links).forEach(([className, url]) => {
        document.querySelectorAll(`.${className}`).forEach(element => {
            element.style.cursor = 'pointer';

            element.addEventListener('click', function (e) {
                if (e.target.closest('a, button')) return;

                window.location.href = url;
            });
        });
    });
});